var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRighticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 15,
    fill: "#A5A2FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 15H15.8334M24.1667 15H25.2573C26.9954 15 27.8644 15 28.3613 15.5552C28.8582 16.1103 28.7622 16.974 28.5703 18.7015L28.3237 20.9203C27.9319 24.4464 27.736 26.2094 26.5495 27.2714C25.363 28.3334 23.5754 28.3334 20 28.3334C16.4247 28.3334 14.637 28.3334 13.4505 27.2714C12.264 26.2094 12.0682 24.4464 11.6764 20.9203L11.4298 18.7015C11.2379 16.974 11.1419 16.1103 11.6388 15.5552C12.1357 15 13.0047 15 14.7428 15H15.8334M24.1667 15C24.1667 12.6989 22.3012 10.8334 20 10.8334C17.7557 10.8334 15.9258 12.6079 15.8368 14.8304C15.8345 14.8867 15.8334 14.9432 15.8334 15",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 18.3333C25 18.7936 24.6269 19.1667 24.1667 19.1667C23.7064 19.1667 23.3333 18.7936 23.3333 18.3333C23.3333 17.8731 23.7064 17.5 24.1667 17.5C24.6269 17.5 25 17.8731 25 18.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 18.3333C16.6667 18.7936 16.2936 19.1667 15.8333 19.1667C15.3731 19.1667 15 18.7936 15 18.3333C15 17.8731 15.3731 17.5 15.8333 17.5C16.2936 17.5 16.6667 17.8731 16.6667 18.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRighticon);
export default __webpack_public_path__ + "static/media/righticon.e71ea50f056180544544c7614427472f.svg";
export { ForwardRef as ReactComponent };